import React, { Component } from 'react';
import emailjs from '@emailjs/browser';

import { buildPath } from '../utils/route_utils.js'
import { updateSEO } from '../utils/seo_utils'

import Navbar from '../components/Navbar'
import AnnouncementBanner from '../components/AnnouncementBanner'
import Breadcrumb from '../components/Breadcrumb'
import Footer from '../components/Footer'

import '../css/ContactUsPage.css';

const EMAILJS_SERVICE_ID = 'service_wwz1o4b';
const EMAILJS_TEMPLATE_ID = 'template_a61j08m';
const EMAILJS_PUBLIC_KEY = 'N0UULto_yoePG1RDl';

class ContactUsPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      lang: this.props.lang,
      title: {"en": "Contact Us", "zh": "聯絡我們", "ja": "お問い合わせ"},
      location: {
        "en": {
          "title": "Location",
          "content": [{"addr": "6F-2, No. 31, Huanke 1st Rd., Zhubei City, Hsinchu County 302, Taiwan (R.O.C.)"}]
        },
        "zh": {
          "title": "地點",
          "content": [{"addr": "302新竹縣竹北市環科一路31號6樓之二"}]
        },
        "ja": {
          "title": "所在地",
          "content": [{"addr": "台湾新竹県竹北市環科一路31号6F-2"}]
        }
      },
      email: {
        "en": { "title": "Email", "content": [
          { addr: "contact@nexuni.com", note: "General inquiries" },
          { addr: "parking@nexuni.com", note: "Parking-related questions" }
        ]},
        "zh": { "title": "信箱", "content": [
          { addr: "contact@nexuni.com", note: "一般詢問" },
          { addr: "parking@nexuni.com", note: "停車相關問題" }
        ]},
        "ja": { "title": "メール", "content": [
          { addr: "contact@nexuni.com", note: "一般的なお問い合わせ" },
          { addr: "parking@nexuni.com", note: "駐車場に関するご質問" }
        ]}
      },
      tele: {
        "en": { "title": "Customer Service", "content": ["+886-3-555-1566"] },
        "zh": { "title": "聯絡電話", "content": ["+886-3-555-1566"] },
        "ja": { "title": "カスタマーサービス", "content": ["+886-3-555-1566"] }
      },
      // Form state
      formData: {
        name: '', company: '', email: '', phone: '', country: '', interest: '', message: ''
      },
      honeypot: '', // bot trap — hidden field
      formStatus: null, // null, 'sending', 'success', 'error'
      toast: null, // { type: 'success'|'error', data: {...} }
      formLabels: {
        en: { name: "Name", company: "Company", email: "Email", phone: "Phone", country: "Country", interest: "Interest", message: "Message", send: "Send Message", success: "Message sent successfully!", error: "Failed to send. Please try email instead.", sending: "Sending...", required: "Required",
              interests: ["Parking Solutions", "Robot Solutions", "Facility Management", "Custom Automation", "Other"] },
        zh: { name: "姓名", company: "公司", email: "信箱", phone: "電話", country: "國家", interest: "感興趣的項目", message: "訊息", send: "送出訊息", success: "訊息已成功送出！", error: "送出失敗，請改用 Email 聯繫。", sending: "送出中...", required: "必填",
              interests: ["停車解決方案", "機器人解決方案", "設施管理", "客製化自動化", "其他"] },
        ja: { name: "お名前", company: "会社名", email: "メール", phone: "電話番号", country: "国", interest: "興味のある分野", message: "メッセージ", send: "送信", success: "メッセージが正常に送信されました！", error: "送信に失敗しました。メールでお問い合わせください。", sending: "送信中...", required: "必須",
              interests: ["駐車ソリューション", "ロボットソリューション", "施設管理", "カスタム自動化", "その他"] }
      },
      toastLabels: {
        en: { title: "Message Sent", subtitle: "A copy has been sent to your email.", name: "Name", company: "Company", email: "Email", phone: "Phone", country: "Country", interest: "Interest", message: "Message", errorTitle: "Send Failed", errorSubtitle: "Please try emailing us directly at contact@nexuni.com." },
        zh: { title: "訊息已送出", subtitle: "副本已寄送至您的信箱。", name: "姓名", company: "公司", email: "信箱", phone: "電話", country: "國家", interest: "感興趣的項目", message: "訊息", errorTitle: "送出失敗", errorSubtitle: "請直接寄信至 contact@nexuni.com。" },
        ja: { title: "送信完了", subtitle: "コピーがメールに送信されました。", name: "お名前", company: "会社名", email: "メール", phone: "電話番号", country: "国", interest: "興味のある分野", message: "メッセージ", errorTitle: "送信失敗", errorSubtitle: "contact@nexuni.com まで直接ご連絡ください。" }
      }
    }

    this.update_lang = this.update_lang.bind(this)
    this.navigate = this.navigate.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.dismissToast = this.dismissToast.bind(this)
    this.formSubmitTime = null;
  }

  componentDidMount() {
    updateSEO('contact', this.state.lang, '/contact');
    this.formLoadTime = Date.now();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  update_lang(newLang) {
    this.props.updateLang(newLang);
  }

  navigate(route) {
    window.location.href = buildPath(this.state.lang, route);
  }

  handleChange(e) {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value }
    });
  }

  dismissToast() {
    this.setState({ toast: null });
  }

  async handleSubmit(e) {
    e.preventDefault();

    // Honeypot check — if filled, it's a bot
    if (this.state.honeypot) {
      // Silently pretend success so bot doesn't retry
      this.setState({ formStatus: 'success' });
      return;
    }

    // Time-based check — form filled in under 2 seconds is suspicious
    if (Date.now() - this.formLoadTime < 2000) {
      this.setState({ formStatus: 'success' });
      return;
    }

    this.setState({ formStatus: 'sending' });

    const fd = this.state.formData;
    const templateParams = {
      from_name: fd.name,
      from_company: fd.company,
      from_email: fd.email,
      from_phone: fd.phone || 'N/A',
      from_country: fd.country || 'N/A',
      interest: fd.interest || 'N/A',
      message: fd.message || 'N/A',
      reply_to: fd.email,
    };

    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        templateParams,
        EMAILJS_PUBLIC_KEY
      );

      this.setState({
        formStatus: 'success',
        toast: { type: 'success', data: { ...fd } },
        formData: { name: '', company: '', email: '', phone: '', country: '', interest: '', message: '' }
      });

      // Auto-dismiss toast after 8 seconds
      setTimeout(() => this.dismissToast(), 8000);

    } catch (err) {
      console.error('EmailJS error:', err);
      this.setState({
        formStatus: 'error',
        toast: { type: 'error', data: { ...fd } }
      });

      setTimeout(() => this.dismissToast(), 8000);
    }
  }

  renderToast() {
    const { toast, lang } = this.state;
    if (!toast) return null;

    const t = this.state.toastLabels[lang];
    const isSuccess = toast.type === 'success';
    const d = toast.data;

    return (
      <div className={`v2_toast_overlay ${toast ? 'v2_toast_visible' : ''}`} onClick={this.dismissToast}>
        <div className={`v2_toast ${isSuccess ? 'v2_toast_success' : 'v2_toast_error'}`} onClick={(e) => e.stopPropagation()}>
          <div className="v2_toast_header">
            <div className="v2_toast_icon">
              {isSuccess ? (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              ) : (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="15" y1="9" x2="9" y2="15" />
                  <line x1="9" y1="9" x2="15" y2="15" />
                </svg>
              )}
            </div>
            <div className="v2_toast_titles">
              <h3>{isSuccess ? t.title : t.errorTitle}</h3>
              <p>{isSuccess ? t.subtitle : t.errorSubtitle}</p>
            </div>
            <button className="v2_toast_close" onClick={this.dismissToast}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>

          {isSuccess && (
            <div className="v2_toast_body">
              <div className="v2_toast_row"><span>{t.name}</span><span>{d.name}</span></div>
              <div className="v2_toast_row"><span>{t.company}</span><span>{d.company}</span></div>
              <div className="v2_toast_row"><span>{t.email}</span><span>{d.email}</span></div>
              {d.phone && <div className="v2_toast_row"><span>{t.phone}</span><span>{d.phone}</span></div>}
              {d.country && <div className="v2_toast_row"><span>{t.country}</span><span>{d.country}</span></div>}
              {d.interest && <div className="v2_toast_row"><span>{t.interest}</span><span>{d.interest}</span></div>}
              {d.message && <div className="v2_toast_row v2_toast_row_msg"><span>{t.message}</span><span>{d.message}</span></div>}
            </div>
          )}
        </div>
      </div>
    );
  }

  render() {
    const lang = this.state.lang;
    const labels = this.state.formLabels[lang];
    const fd = this.state.formData;
    const isSending = this.state.formStatus === 'sending';

        return (
            <div className={"contact_page " + lang}>
              <AnnouncementBanner lang={lang} />
              <Navbar lang={lang} updateLangFunc={this.update_lang} />
              <Breadcrumb lang={lang} items={[{ label: { zh: "聯絡我們", en: "Contact Us", ja: "お問い合わせ" } }]} />

              <div className="v2_contact_layout">
                <div className="v2_contact_info_side">
                  <h1 className="v2_contact_us_title">{this.state.title[lang]}</h1>

                  <div className="v2_contact_info_group">
                    <h3 className="v2_contact_info_label">{this.state.location[lang].title}</h3>
                    {this.state.location[lang].content.map((item, idx) =>
                      <div key={idx} className="v2_contact_info_item">
                        {item.title && <strong>{item.title}</strong>}
                        <p>{item.addr}</p>
                      </div>
                    )}
                  </div>

                  <div className="v2_contact_info_group">
                    <h3 className="v2_contact_info_label">{this.state.email[lang].title}</h3>
                    {this.state.email[lang].content.map((email, idx) =>
                      <div key={idx} className="v2_contact_email_item">
                        <a href={'mailto:' + email.addr} className="v2_contact_email_link">{email.addr}</a>
                        <span className="v2_contact_email_note">{email.note}</span>
                      </div>
                    )}
                  </div>

                  <div className="v2_contact_info_group">
                    <h3 className="v2_contact_info_label">{this.state.tele[lang].title}</h3>
                    {this.state.tele[lang].content.map((tel, idx) =>
                      <p key={idx}>{tel}</p>
                    )}
                  </div>
                </div>

                <div className="v2_contact_form_side">
                  <form className="v2_contact_form" onSubmit={this.handleSubmit}>
                    {/* Honeypot — hidden from humans, bots will fill it */}
                    <input
                      type="text"
                      name="website_url"
                      value={this.state.honeypot}
                      onChange={(e) => this.setState({ honeypot: e.target.value })}
                      style={{ position: 'absolute', left: '-9999px', opacity: 0, height: 0, width: 0, tabIndex: -1 }}
                      tabIndex={-1}
                      autoComplete="off"
                    />

                    <div className="v2_form_row">
                      <div className="v2_form_field">
                        <label>{labels.name} *</label>
                        <input type="text" name="name" value={fd.name} onChange={this.handleChange} required />
                      </div>
                      <div className="v2_form_field">
                        <label>{labels.company} *</label>
                        <input type="text" name="company" value={fd.company} onChange={this.handleChange} required />
                      </div>
                    </div>
                    <div className="v2_form_row">
                      <div className="v2_form_field">
                        <label>{labels.email} *</label>
                        <input type="email" name="email" value={fd.email} onChange={this.handleChange} required />
                      </div>
                      <div className="v2_form_field">
                        <label>{labels.phone}</label>
                        <input type="tel" name="phone" value={fd.phone} onChange={this.handleChange} />
                      </div>
                    </div>
                    <div className="v2_form_row">
                      <div className="v2_form_field">
                        <label>{labels.country}</label>
                        <input type="text" name="country" value={fd.country} onChange={this.handleChange} />
                      </div>
                      <div className="v2_form_field">
                        <label>{labels.interest}</label>
                        <select name="interest" value={fd.interest} onChange={this.handleChange}>
                          <option value="">--</option>
                          {labels.interests.map((opt, idx) =>
                            <option key={idx} value={opt}>{opt}</option>
                          )}
                        </select>
                      </div>
                    </div>
                    <div className="v2_form_field v2_form_full">
                      <label>{labels.message}</label>
                      <textarea name="message" rows="5" value={fd.message} onChange={this.handleChange}></textarea>
                    </div>
                    <button type="submit" className="v2_form_submit" disabled={isSending}>
                      {isSending ? labels.sending : labels.send}
                    </button>
                  </form>
                </div>
              </div>

              {this.renderToast()}

              <Footer lang={lang} navigate={this.navigate}/>

            </div>

        );}

}
export default ContactUsPage;
